<p style="font-weight: normal;">
    La prévoyance n’a désormais plus de secret pour vous!<br><br>
    Après avoir réalisé votre bilan personnalisé<sup>(1)</sup>, découvrez nos assurances prévoyance et les montants adaptés à votre profil.<br>
</p>
@if (!(uniqueGavSecuriteObseques$ | ngrxPush)) {
  <span style="color:#ff8800">Envie d’en savoir plus ?</span>
  <br>
  <p style="font-weight: bold;color:#ff8800" class="mb-2">
      Cochez ou décochez les cases pour ajuster votre estimation tarifaire<sup>(1)</sup> :
  </p>
}
@if (uniqueGavSecuriteObseques$ | ngrxPush) {
  <br>
  <p style="font-weight: bold;color:#ff8800" class="mb-2">
      Découvrez ci-dessous votre approche tarifaire(1) :
  </p>
}
